{
  "name": "MotiliWeb",
  "version": "10.10.2",
  "sprint": "216",
  "build": "564c4cdd6b",
  "description": "This is the release for 10.9.3",
  "main": "index.html",
  "private": true,
  "scripts": {
    "build": "NODE_OPTIONS=--max-old-space-size=16384 vite build",
    "build:dev": "npm run build --mode development",
    "build-local": "VITE_ENV=local npm run build",
    "build-dev": "VITE_ENV=dev npm run build",
    "build-dashboard-devintg": "VITE_ENV=dashboarddevintg npm run build",
    "build-dev2": "VITE_ENV=dev2 npm run build",
    "build-dev2cs": "VITE_ENV=dev2cs npm run build",
    "build-docker": "VITE_ENV=docker npm run build",
    "build-tax": "VITE_ENV=docker npm run build",
    "build-pim": "npm run build-docker",
    "build-sched": "VITE_ENV=docker npm run build",
    "build-qa": "VITE_ENV=qa npm run build",
    "build-sandbox": "VITE_ENV=docker npm run build && curl -s https://app.sandbox.motilidev.com/env.json -o build/env.json",
    "build-stage": "VITE_ENV=stage npm run build",
    "build-prod": "VITE_ENV=prod npm run build",
    "build-coverage": "VITE_ENV=dev BABEL_ENV=coverage COVERAGE_HOST=ec2-52-34-230-202.us-west-2.compute.amazonaws.com COVERAGE_PORT=1231 npm run build",
    "deploy-dev": "npm run build-dev && aws s3 sync ./build s3://app.motilidev.com/ --delete",
    "deploy-dev2": "npm run build-dev2 && aws s3 sync ./build s3://app2.motilidev.com/ --delete",
    "deploy-dev2cs": "npm run build-dev2cs && aws s3 sync ./build s3://sandbox.motilidev.com/ --delete && aws cloudfront create-invalidation --distribution-id E3O7A3DJMTXHCE --paths '/*'",
    "deploy-qa": "npm run build-qa && aws s3 sync ./build s3://app.motilitest.com/ --delete",
    "deploy-coverage": "npm run build-coverage && aws s3 sync ./build s3://app.motilicoverage.com --delete",
    "preview": "vite preview",
    "preview-tax": "npm run build-tax && curl -s https://app.tax.motilitest.com/env.json -o build/env.json && npm run preview",
    "preview-qa": "npm run build-qa && npm run preview",
    "start": "npm run start-dev2",
    "start-local-coverage": "VITE_ENV=local BABEL_ENV=coverage COVERAGE_HOST=localhost COVERAGE_PORT=1231 vite",
    "start-local": "VITE_ENV=local vite",
    "start-dev": "VITE_ENV=dev vite",
    "start-dev2": "VITE_ENV=dev2 vite",
    "start-dashboardlocal": "VITE_ENV=dashboardlocal vite",
    "start-dev2cs": "VITE_ENV=dev2cs vite",
    "start-pim": "curl -s https://app.pim.motilidev.com/env.json -o public/env.json && VITE_ENV=docker vite",
    "start-qa": "VITE_ENV=qa vite",
    "start-stage": "VITE_ENV=stage vite",
    "start-tax": "curl -s https://app.tax.motilitest.com/env.json -o public/env.json && VITE_ENV=docker vite",
    "start-sched": "curl -s https://app.sched.motilidev.com/env.json -o public/env.json && VITE_ENV=docker vite",
    "start-sandbox": "curl -s https://app.sandbox.motilidev.com/env.json -o public/env.json && VITE_ENV=docker vite",
    "start-smartsheets": "curl -s https://app.smartsheets.motilidev.com/env.json -o public/env.json && VITE_ENV=docker vite",
    "start-dscs": "curl -s https://app.dscs.motilidev.com/env.json -o public/env.json && VITE_ENV=docker vite",
    "start-hoth": "curl -s https://app.hoth.motilidev.com/env.json -o public/env.json && VITE_ENV=docker vite",
    "lint": "eslint 'src/**/*.{js,ts,tsx,jsx}'",
    "lint:fix": "npm run lint -- --quiet --fix",
    "nibble": "eslint-nibble 'src/**/*.{js,ts,tsx,jsx}'",
    "prepare": "husky install",
    "test": "vitest",
    "test:watch": "vitest --watch",
    "test:ui": "vitest --ui",
    "test:coverage": "vitest --coverage",
    "test:ci": "vitest run --reporter=verbose --coverage",
    "test:strict": "vitest run --bail=1 --isolate=false"
  },
  "author": "Motili",
  "license": "",
  "dependencies": {
    "@amplitude/analytics-browser": "^2.11.6",
    "@amplitude/analytics-types": "^2.8.2",
    "@auth0/auth0-react": "^2.3.0",
    "@emotion/react": "^11.14.0",
    "@emotion/styled": "^11.14.1",
    "@googlemaps/markerclusterer": "^2.5.3",
    "@hookform/resolvers": "^2.9.11",
    "@jsonforms/core": "^3.1.0",
    "@jsonforms/react": "^3.1.0",
    "@motili/scheduler-ui": "2.0.0",
    "@motili/ui": "8.0.x",
    "@mui/icons-material": "^7.3.5",
    "@mui/material": "^7.3.5",
    "@mui/x-charts": "^7.27.0",
    "@mui/x-data-grid-premium": "^7.29.9",
    "@mui/x-license": "^7.26.0",
    "@reduxjs/toolkit": "^2.10.1",
    "@sentry/browser": "^10.47.0",
    "@sentry/cli": "^2.46.0",
    "@sentry/react": "^10.47.0",
    "@sentry/vite-plugin": "^4.6.1",
    "@types/papaparse": "^5.5.1",
    "@vis.gl/react-google-maps": "^1.7.1",
    "aws-sdk": "^2.988.0",
    "axios": "1.14.0",
    "bootstrap": "^5.3.8",
    "bootstrap-sass": "^3.3.7",
    "broadcast-channel": "^7.1.0",
    "classnames": "^2.2.6",
    "cloudinary-react": "^1.1.1",
    "core-js": "^3.6.4",
    "country-to-currency": "^1.0.5",
    "dayjs": "^1.11.9",
    "dompurify": "^3.2.7",
    "exceljs": "^4.4.0",
    "filesize": "^4.1.2",
    "firebase": "^9.20.0",
    "font-awesome": "^4.7.0",
    "fuse.js": "^3.4.5",
    "handlebars": "^4.0.12",
    "js-file-download": "^0.4.12",
    "jszip": "^3.2.2",
    "jwt-decode": "^4.0.0",
    "lodash": "^4.17.4",
    "moment": "^2.18.1",
    "moment-timezone": "^0.5.43",
    "natural-orderby": "^2.0.3",
    "papaparse": "^5.5.2",
    "prop-types": "^15.6.0",
    "react": "19.2.6",
    "react-autosuggest": "^9.1.0",
    "react-bootstrap": "^2.10.10",
    "react-cropper": "^2.3.3",
    "react-dom": "19.2.6",
    "react-dropzone": "^14.3.8",
    "react-error-boundary": "^4.0.12",
    "react-highlight-words": "^0.21.0",
    "react-hook-form": "^7.45.2",
    "react-infinite-scroll-component": "^6.1.0",
    "react-is": "^18.3.1",
    "react-list": "^0.8.18",
    "react-moment-proptypes": "^1.5.0",
    "react-pdf": "^10.4.1",
    "react-redux": "^9.2.0",
    "react-responsive-carousel": "^3.2.23",
    "react-router": "^7.13.2",
    "react-router-bootstrap": "^0.26.2",
    "react-select": "^5.2.1",
    "react-toastify": "^11.1.0",
    "react-tooltip": "^6.0.4",
    "react-virtualized": "^9.18.5",
    "redux-persist": "^6.0.0",
    "sass": "^1.62.0",
    "styled-components": "^6.1.19",
    "superagent": "^3.5.2",
    "use-debounce": "^7.0.1",
    "use-interval": "^1.3.0",
    "uuid": "^9.0.0",
    "workbox-background-sync": "^7.4.0",
    "workbox-broadcast-update": "^7.4.0",
    "workbox-cacheable-response": "^7.4.0",
    "workbox-core": "^7.4.0",
    "workbox-expiration": "^7.4.0",
    "workbox-google-analytics": "^7.4.0",
    "workbox-navigation-preload": "^7.4.0",
    "workbox-precaching": "^7.4.0",
    "workbox-range-requests": "^7.4.0",
    "workbox-routing": "^7.4.0",
    "workbox-strategies": "^7.4.0",
    "workbox-streams": "^7.4.0",
    "yup": "^0.28.1"
  },
  "devDependencies": {
    "@testing-library/jest-dom": "^6.9.1",
    "@testing-library/react": "^16.3.0",
    "@types/core-js": "^2.5.5",
    "@types/filesize": "^4.2.0",
    "@types/google.maps": "^3.58.1",
    "@types/json2csv": "^5.0.3",
    "@types/lodash": "^4.14.149",
    "@types/node": "^24.10.8",
    "@types/prop-types": "^15.7.5",
    "@types/react": "^19.0.0",
    "@types/react-addons-shallow-compare": "^0.14.22",
    "@types/react-autosuggest": "^9.3.14",
    "@types/react-bootstrap": "^0.32.22",
    "@types/react-dom": "^19.0.0",
    "@types/react-highlight-words": "^0.16.4",
    "@types/react-list": "^0.8.7",
    "@types/react-redux": "^7.1.25",
    "@types/react-router-bootstrap": "^0.26.3",
    "@types/react-virtualized": "^9.21.22",
    "@types/superagent": "^4.1.10",
    "@types/uuid": "^3.4.10",
    "@types/yup": "^0.28.3",
    "@typescript-eslint/eslint-plugin": "^8.48.0",
    "@typescript-eslint/parser": "^8.48.0",
    "@vitejs/plugin-react": "^6.0.1",
    "@vitest/coverage-v8": "^4.0.16",
    "@vitest/ui": "^4.0.16",
    "eslint": "^8.57.1",
    "eslint-config-airbnb": "^19.0.4",
    "eslint-config-prettier": "^9.0.0",
    "eslint-import-resolver-typescript": "^4.4.5",
    "eslint-nibble": "^8.1.0",
    "eslint-plugin-prettier": "^5.0.0",
    "eslint-plugin-react-19-upgrade": "^1.9.0",
    "husky": "^8.0.0",
    "jsdom": "^27.3.0",
    "lint-staged": "^10.0.7",
    "polished": "^4.2.2",
    "prettier": "^3.1.0",
    "typescript": "^5.2.2",
    "vite": "^8.0.16",
    "vite-plugin-pwa": "^1.2.0",
    "vite-plugin-svgr": "^5.0.0",
    "vite-tsconfig-paths": "^6.1.1",
    "vitest": "^4.0.15",
    "workbox-window": "^7.4.0"
  },
  "overrides": {
    "react": "19.2.6",
    "react-dom": "19.2.6",
    "@types/react": "^19.0.0",
    "@types/react-dom": "^19.0.0",
    "@motili/ui": "8.0.x",
    "react-is": "^18.3.1",
    "react-router-dom": "^7.13.2",
    "sugarss": "^5.0.0",
    "react-tooltip": "^6.0.4",
    "redux": "^5.0.0",
    "styled-components": "^6.1.19",
    "stylis": "^4.3.6",
    "@mui/system": "^7.3.5",
    "vite-plugin-pwa": {
      "vite": "$vite"
    }
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ]
  },
  "fork-ts-checker": {
    "typescript": {
      "enabled": true,
      "memoryLimit": 16384
    }
  },
  "engines": {
    "node": ">=24.13.0",
    "npm": ">=11.17.0"
  }
}
